import React from 'react';
import styled from '@emotion/styled';
import { motion } from 'framer-motion';
import { theme } from './theme';

const AppContainer = styled.div`
  min-height: 100vh;
  background-color: ${theme.colors.background};
  color: ${theme.colors.text};
  font-family: ${theme.fonts.main};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  padding: 1rem;
`;

const BackgroundPattern = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    linear-gradient(45deg, ${theme.colors.primary}22 25%, transparent 25%),
    linear-gradient(-45deg, ${theme.colors.secondary}22 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, ${theme.colors.primary}22 75%),
    linear-gradient(-45deg, transparent 75%, ${theme.colors.secondary}22 75%);
  background-size: 20px 20px;
  background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
  opacity: 0.5;
  z-index: 1;
`;

const ContentWrapper = styled.div`
  position: relative;
  z-index: 2;
  text-align: center;
  width: 100%;
  max-width: 800px;
  padding: 0 1rem;
`;

const Title = styled(motion.h1)`
  font-size: clamp(2.5rem, 8vw, 5rem);
  font-weight: 700;
  letter-spacing: 0.2em;
  color: ${theme.colors.text};
  text-transform: uppercase;
  margin: 0;
  padding: 0;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  line-height: 1.2;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    letter-spacing: 0.1em;
  }
`;

const AccentLine = styled(motion.div)`
  width: clamp(60px, 20vw, 100px);
  height: 4px;
  background: linear-gradient(90deg, ${theme.colors.primary}, ${theme.colors.secondary});
  margin: 2rem auto;
  border-radius: 2px;
`;

const Contact = styled(motion.footer)`
  position: absolute;
  bottom: 2rem;
  color: ${theme.colors.textSecondary};
  font-size: clamp(0.8rem, 2vw, 0.9rem);
  letter-spacing: 0.1em;
  text-align: center;
  width: 100%;
  padding: 0 1rem;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    position: relative;
    bottom: 0;
    margin-top: 2rem;
  }
`;

const ContactLink = styled.a`
  color: ${theme.colors.textSecondary};
  text-decoration: none;
  transition: all 0.3s ease;
  display: inline-block;
  padding: 0.5rem;

  &:hover {
    color: ${theme.colors.accent};
  }
`;

function App() {
  return (
    <AppContainer>
      <BackgroundPattern />
      <ContentWrapper>
        <Title
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          Totemic
        </Title>
        <Title
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.2, ease: "easeOut" }}
        >
          Studios
        </Title>
        <AccentLine
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        />
      </ContentWrapper>
      <Contact
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1, duration: 0.8 }}
      >
        <ContactLink href="mailto:contact@totemicstudios.com">
          contact@totemicstudios.com
        </ContactLink>
      </Contact>
    </AppContainer>
  );
}

export default App;
